
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from "@material-ui/lab";

import React from "react";
const useStyles = makeStyles(() => ({
  roundedText: {
    borderRadius: 8,
  },
}));
const CustomSkeleton = ({ count = 1 }) => {
  const classes = useStyles();
  return (
    <div style={{width:"100%"}}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant="text"
          width="100%"
          height={18}
         className={`skeleton-animation ${classes.roundedText}`}
        />
      ))}
    </div>
  );
};

export default CustomSkeleton;
